import { useState } from "react";
import { PropTypes } from 'prop-types'

const useForm = (initialState = {}, onSubmit) => {
    const [formData, setFormData] = useState(initialState);

    const handleInputChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value })
    }

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    }

    return { formData, handleInputChange, handleSubmit, setFormData };
}
useForm.propTypes = {
	initialState: PropTypes.object,
    onSubmit: PropTypes.func
}
export default useForm